import isNull from 'lodash/isNull';
import { useEffect, useState } from 'react';

const isEllipsisActive = (el: HTMLElement | null) => {
  if (isNull(el)) return false;

  return el.scrollWidth !== el.offsetWidth ? el.scrollWidth > el.offsetWidth : checkRanges(el);
};

function checkRanges(el: HTMLElement) {
  const range = new Range();
  if (!('getBoundingClientRect' in range)) return false;

  range.selectNodeContents(el);

  const rangeRect = range.getBoundingClientRect();
  const elRect = el.getBoundingClientRect();

  // assumes ltr direction
  return rangeRect.right > elRect.right;
}

export const useEllipsisTooltip = (fullTitle: string | undefined) => {
  const [isUsingEllipsis, setIsUsingEllipsis] = useState(false);
  const [observedElement, setObservedElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const el = observedElement;
    if (!el) return;

    const observer = new ResizeObserver(() => {
      setIsUsingEllipsis(isEllipsisActive(el));
    });

    observer.observe(el);

    setIsUsingEllipsis(isEllipsisActive(el));

    return () => observer.disconnect();
  }, [fullTitle, observedElement]);

  const ref = (el: HTMLElement | null) => {
    setObservedElement(el);
  };

  const title = isUsingEllipsis ? fullTitle : '';

  return { ref, title };
};
